import React, { useCallback } from 'react';
import { IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useSnackbar } from 'notistack';
import noop from 'lodash/noop';

export default function createSnackbarAction({ iconComponent, onClick }) {
    return (snackbarId) => (
        <SnackbarAction
            iconComponent={iconComponent}
            onClick={onClick}
            snackbarId={snackbarId}
        />
    );
}

function SnackbarAction(props) {
    const {
        iconComponent: Icon,
        onClick: propsOnClick = noop,
        snackbarId
    } = props;

    const { closeSnackbar } = useSnackbar();
    const classes = useStyles(props);

    const onClick = useCallback(() => {
        closeSnackbar(snackbarId);
        propsOnClick();
    }, [propsOnClick, snackbarId]);

    return (
        <IconButton onClick={onClick} size="large">
            <Icon className={classes.icon} />
        </IconButton>
    );
}

const useStyles = makeStyles({
    icon: {
        color: '#fff'
    }
});